class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
    this.minutesElement = this.querySelector('.minutes');
    this.secondsElement = this.querySelector('.seconds');
    
    // Calculate time remaining until next 30 minute mark
    const now = new Date();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const timeToNext30 = (30 - (minutes % 30)) * 60 - seconds;
    
    this.startCountdown(timeToNext30);
  }

  startCountdown(totalSeconds) {
    let remaining = totalSeconds;
    
    const updateDisplay = () => {
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;
      
      this.minutesElement.textContent = String(minutes);
      this.secondsElement.textContent = String(seconds).padStart(2, '0');
      
      if (remaining === 0) {
        // Reset to 30 minutes when it hits zero
        remaining = 30 * 60;
      }
      remaining--;
    };

    // Initial display
    updateDisplay();
    
    // Update every second
    this.timer = setInterval(updateDisplay, 1000);
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer); 